import Image from "next/image"
import styles from "./login.module.css"

/** Static, locally served artwork; attribution is in docs/ASSET_ATTRIBUTIONS.md. */
export function LoginBackground() {
  return (
    <div aria-hidden="true" className={`pointer-events-none absolute inset-0 overflow-hidden ${styles.background}`}>
      <Image
        src="/login-infrastructure.webp"
        alt=""
        fill
        sizes="100vw"
        priority
        unoptimized
        className={styles.image}
      />
    </div>
  )
}
